/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_Phone_FormatInputs */

const es_co2_signup_error_phone_format = /** @type {(inputs: Signup_Error_Phone_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa formato internacional, p. ej. +573001234567`)
};

/**

* @param {Signup_Error_Phone_FormatInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_error_phone_format = /** @type {((inputs?: Signup_Error_Phone_FormatInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_Phone_FormatInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_phone_format(inputs)
});